$drawer-sizes: (
  sm: 16rem,
  md: 22.5rem,
  lg: 30rem,
  xl: 45rem,
);

.signet-drawer {
  height: 100%;
  max-width: 90%;
  position: fixed;
  top: 0;
  bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: white;
  padding-top: 16px;
  transition: all 0.5s ease-in-out;
  z-index: 9999;
  font-family: Lato;
  font-weight: 400;

  @each $direction in (left, right) {
    &.#{$direction} {
      border-right: 1px solid var(--gray-100);

      @each $key, $value in $drawer-sizes {
        &.size-#{$key} {
          width: $value;
          #{$direction}: -$value;
          transition: all 0.5s ease;
        }
      }

      &.show {
        visibility: visible;
        #{$direction}: 0;
        transition: all 0.5s ease;
      }
    }
  }

  .drawer-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: var(--text-primary);
    padding: 24px 0 0 0;
    margin-bottom: 40px;
    padding: 0 20px;

    .drawer-title {
      font-size: 16px;
      font-weight: 600;
    }

    .drawer-close {
      .icon {
        color: var(--text-primary);
        cursor: pointer;
      }
    }
  }

  .drawer-body {
    padding: 16px 0;
  }
}
